// extracted by mini-css-extract-plugin
export default {"custom-bg":"signUp_custom-bg__V7+Uy"};